import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import {
	RegistryTransaction,
	RegistryTransactionCreatePayload,
	RegistryTransactionsListResponse,
} from '../models/registryTransaction';
import { CompanyShareholder, Shareholder } from 'core/models/shareholder';

export const onGetRegistryTransactionsList = async (page: number = 1) => {
	try {
		const response = await axios.get<JsonResponse<RegistryTransactionsListResponse>>('dashboard/actions/registry-transaction', {
			params: { page },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetRegistryTransactionById = async (id: string) => {
	try {
		const response = await axios.get<JsonResponse<RegistryTransaction>>(`dashboard/actions/registry-transaction/${id}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCheckSellerNationalId = async (national_id: string) => {
	try {
		const response = await axios.get<JsonResponse<{ company_shareholder: CompanyShareholder }>>(
			`dashboard/actions/registry-transaction/check-company-shareholder`,
			{
				params: { national_id },
			},
		);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onSubmitRegistryTransaction = async (data: RegistryTransactionCreatePayload) => {
	try {
		const response = await axios.post<JsonResponse<RegistryTransaction>>('dashboard/actions/registry-transaction', data);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
